<script>
import AkDialog from '@components/general/AkDialog.vue';
import AkDialogHeadless from '@components/general/AkDialogHeadless.vue';
import AkButtonActionV2 from '@components/v2/general/AkButtonActionV2.vue';

export default {
  name: 'AkDialogConfirm',
  components: {AkButtonActionV2, AkDialogHeadless, AkDialog},
  props: {
    validateLabel: {
      type: String,
      default: 'Confirmer',
    },
    label: {
      type: String,
      required: false,
    },
    onResolve: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      promise: null,
      resolvePromise: null,
      rejectPromise: null,
    };
  },
  methods: {
    confirm() {
      this.promise = new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
      this.$refs.dialog.show();
      return this.promise;
    },
    cancel() {
      this.$refs.dialog.hide();
      if (this.rejectPromise) {
        this.rejectPromise();
      }

      this.promise = null;
      this.resolvePromise = null;
      this.rejectPromise = null;
    },
    resolve() {
      this.$refs.dialog.hide();

      if (this.resolvePromise) {
        this.resolvePromise();
      }

      this.promise = null;
      this.resolvePromise = null;
      this.rejectPromise = null;

      if (this.onResolve) this.onResolve.call();
    },
  },
  beforeUnmount() {
    this.cancel();
  },
};
</script>

<template>
  <AkDialogHeadless
    width="320px"
    content-class="!p-0"
    ref="dialog"
    :validate-label="validateLabel"
    @cancel="cancel"
    :show-cancel-button="false"
    :show-validate-button="false">
    <div class="flex flex-col gap-12 p-4 pt-8">
      <div v-if="label" class="flex flex-col gap-4 items-center">
        <i
          class="ga-icon ga-question-mark-circle text-orange-500 rounded-full h-[68px] w-[68px] flex items-center justify-center text-[40px] bg-orange-50 p-2" />
        <span class="text-lg font-semibold text-grey-900 text-center w-full block">
          {{ label }}
        </span>
      </div>
      <slot v-else></slot>
      <div class="flex items-center justify-between">
        <AkButtonActionV2 label="Annuler" class="btn-grey !h-12 !px-6 font-medium" @click="cancel" />
        <AkButtonActionV2 :label="validateLabel" class="!px-6 !h-12 font-medium" @click="resolve" />
      </div>
    </div>
  </AkDialogHeadless>
</template>

<style scoped></style>
